
const initialState = 0;

const searchDetailsTorrensCertificateReducer = (state = initialState, action) => {
   
    if (action.type === 'DISPLAY_TORRENS_CERTIFICATE_SEARCH_DETAILS') {
        return action.id;
    }

    if (action.type === 'UPDATE_SEARCH_RESULTS') {
        return 0;
    }

    if (action.type === 'RESET_SEARCH_DETAILS') {
        return 0;
    }
    
    return state;
};
export default searchDetailsTorrensCertificateReducer;